import { t } from '@lingui/core/macro';
import { FieldText, FieldTextProps } from '@luminovo/design-system';
import type { JSX } from 'react';

export interface FieldOfferNumberProps extends FieldTextProps {}

export function FieldOfferNumber({ ...props }: FieldOfferNumberProps): JSX.Element {
    return <FieldText placeholder={t`Offer number`} {...props} />;
}
